import Checkbox from 'components/ui/Checkbox';
import { CSVTableRowProps } from 'types';

const DeleteColumnRow = ({ rowIndex, columnLabels, isEditMode, values, useFormReturn }: CSVTableRowProps) => {
  const { register, setValue } = useFormReturn;

  if (isEditMode) {
    return (
      <tr>
        <th>미사용</th>
        <td>
          <div>
            <Checkbox
              id="allDeleteColumn"
              {...register('allDeleteColumn', {
                onChange: (event) => {
                  setValue(
                    'deleteColumns',
                    values.map(() => event.currentTarget.checked)
                  );
                },
              })}
            />
          </div>
        </td>
        {columnLabels.map((label, i) => (
          <td key={`col/${label}/row/${rowIndex}/edit`}>
            {values?.[i] !== undefined && (
              <div>
                <Checkbox id={`deleteColumn/${i}`} {...register(`deleteColumns.${i}`)} />
              </div>
            )}
          </td>
        ))}
      </tr>
    );
  }

  return (
    <tr>
      <th>{rowIndex}</th>
      {columnLabels.map((label) => (
        <td key={`col/${label}/row/${rowIndex}`}></td>
      ))}
    </tr>
  );
};

export default DeleteColumnRow;
